import createIcon from '../../createIcon';

/**
 * @component @name Score
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiA1SDEzLjVWOEwxNS41IDVIMTcuMkwxNS4yIDhMMTcuMiAxMUgxNS41TDEzLjUgOFYxMUgxMlY1Wk03IDcuMjVIOS41VjYuNUg3VjVIMTFWOC43NUg4LjVWOS41SDExVjExSDdWNy4yNVpNMTkgMTNMMTMgMTlMOSAxNUw1IDE5VjE2LjVMOSAxMi41TDEzIDE2LjVMMTkgMTAuNVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Score = createIcon('Score', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 5H13.5V8L15.5 5H17.2L15.2 8L17.2 11H15.5L13.5 8V11H12V5ZM7 7.25H9.5V6.5H7V5H11V8.75H8.5V9.5H11V11H7V7.25ZM19 13L13 19L9 15L5 19V16.5L9 12.5L13 16.5L19 10.5V13Z',
      key: '1ccvtw',
    },
  ],
]);

export default Score;
